import { render, staticRenderFns } from "./LearnerPage.vue?vue&type=template&id=27da57d0"
import script from "./LearnerPage.vue?vue&type=script&lang=js"
export * from "./LearnerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports